import type {ChecklistFileItem, ChecklistRelatedItem} from "../../types";

export const FileRef = ({
    fileItem,
}: {
    fileItem: ChecklistFileItem;
    relatedItem?: ChecklistRelatedItem;
}) => {
    if (fileItem.objectType !== "file") return null;

    const url = `/dibapi/document/file?resourceId=${encodeURIComponent(fileItem.id)}`;
    const filename = fileItem.subname;

    return (
        <li>
            <a href={url} download={filename}>
                {filename}
            </a>
        </li>
    );
};
